export const resource = {
    ckEditor4: '/static/lib/ckeditor-full/ckeditor.js?v=1.0.4',
    ckEditor5: '/static/lib/ckeditor5/bundle.js?v=1.3.079',
    ckEditor5Perview: '/npmanager/static/lib/ckeditor5/preview.css?v=1.3.053',
    imageEditor: '/static/lib/filerobot/image-editor_4.5.1.min.js?v=1.0.3',
    base64: '/static/lib/js-base64/base64.min.js',
    jsencrypt: '/static/lib/jsencrypt.js',
};
